var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"mousmove":_vm.checkStatusNavbar}},[_c('header-component'),_c('content-component'),_c('footer-component'),_c('toast-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }